"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCachedNotificationHashlist = exports.hasNotificationSession = exports.getLoggedStatus = exports.setCachedNotifications = exports.getCachedNotifications = exports.getCookie = exports.decodeURIObject = void 0;
const constants_1 = require("../constants");
const SecureUserStorageRaw = __importStar(require("@gcloud-npm/utils.secure.user-secure-storage"));
const resolveSecureUserStorage = () => {
    var _a, _b;
    return (SecureUserStorageRaw === null || SecureUserStorageRaw === void 0 ? void 0 : SecureUserStorageRaw.SecureUserStorage) ||
        ((_a = SecureUserStorageRaw === null || SecureUserStorageRaw === void 0 ? void 0 : SecureUserStorageRaw.default) === null || _a === void 0 ? void 0 : _a.SecureUserStorage) ||
        ((_b = SecureUserStorageRaw === null || SecureUserStorageRaw === void 0 ? void 0 : SecureUserStorageRaw.default) === null || _b === void 0 ? void 0 : _b.default) ||
        (SecureUserStorageRaw === null || SecureUserStorageRaw === void 0 ? void 0 : SecureUserStorageRaw.default) ||
        SecureUserStorageRaw;
};
const SecureUserStorage = resolveSecureUserStorage();
if (typeof SecureUserStorage !== "function") {
    throw new TypeError("SecureUserStorage export is not a constructor. Verify @gcloud-npm/utils.secure.user-secure-storage package format.");
}
const currentEnv = process.env.NEXT_PUBLIC_ENV_NAME;
const secureUserStorage = new SecureUserStorage();
const COOKIE_NAME_LOGGED = "seth-session-logged";
const COOKIE_NAME_SOFT_LOGGED = "seth-session-softlogged";
const SC_LOGGED_COOKIE_NAME = "sc.logged";
function decodeURIObject(obj) {
    let res = null;
    try {
        res = JSON.parse(decodeURIObject(obj));
    }
    catch (e) {
        console.log("Failed to decode URI Object");
    }
    return res;
}
exports.decodeURIObject = decodeURIObject;
function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
exports.getCookie = getCookie;
function getCachedNotifications({ userId }) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const persistedInfo = yield secureUserStorage.getUserStore({ id: userId });
        let cachedNotifications = (_a = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.notifications) === null || _a === void 0 ? void 0 : _a.notifications;
        let cachedNotificationList = ((_b = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.notifications) === null || _b === void 0 ? void 0 : _b.notificationList) || [];
        let cachedUnreadNotifications = ((_c = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.notifications) === null || _c === void 0 ? void 0 : _c.unreadNotifications) || [];
        return {
            cachedNotifications,
            cachedNotificationList,
            cachedUnreadNotifications,
        };
    });
}
exports.getCachedNotifications = getCachedNotifications;
function setCachedNotifications({ userId, notifications, notificationList, unreadNotifications, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const prev = (yield secureUserStorage.getUserStore({ id: userId })) || {};
        prev.notifications = Object.assign(Object.assign({}, ((prev === null || prev === void 0 ? void 0 : prev.notifications) || {})), { notifications: notifications, notificationList: Array.isArray(notificationList) ? notificationList : [], unreadNotifications });
        yield secureUserStorage.setUserStore({
            id: userId,
            data: prev,
        });
    });
}
exports.setCachedNotifications = setCachedNotifications;
function getLoggedStatus() {
    const isLogged = getCookie(COOKIE_NAME_LOGGED);
    const isSoftLogged = getCookie(COOKIE_NAME_SOFT_LOGGED);
    const isScLogged = getCookie(SC_LOGGED_COOKIE_NAME);
    if (isLogged || isScLogged || currentEnv === "local") {
        return constants_1.LOGGED_STATUS.LOGGED;
    }
    if (isSoftLogged) {
        return constants_1.LOGGED_STATUS.SOFTLOGGED;
    }
    return constants_1.LOGGED_STATUS.PUBLIC;
}
exports.getLoggedStatus = getLoggedStatus;
function hasNotificationSession() {
    return getLoggedStatus() !== constants_1.LOGGED_STATUS.PUBLIC;
}
exports.hasNotificationSession = hasNotificationSession;
function setCachedNotificationHashlist({}) { }
exports.setCachedNotificationHashlist = setCachedNotificationHashlist;
//# sourceMappingURL=storage.js.map